
/*
  =====
  Gorgias Chat Functions
  =====
*/
let GChat = () => {
  let overlay = {
    chatBtn: {
      small: undefined,
      large: undefined,
    },
    closeChatBtn: undefined,
  };

  let gorgias = {
    container: undefined,
    chatBtn: undefined,
    chatWindow: undefined,
  };

  let interval = {
    chat: undefined,
    chatBtn: undefined,
  };

  let timeout = {
    chat: undefined,
  };

  /*
    =====
    Init
    =====
  */
  function init() {
    // Overlay
    overlay.chatBtn.small = document.querySelector(".overlay-chat-btn__container .overlay-chat-btn.overlay-chat-btn--small");
    overlay.chatBtn.large = document.querySelector(".overlay-chat-btn__container .overlay-chat-btn.overlay-chat-btn--large");
    overlay.chatBtn.small.addEventListener("click", handleShowClick);
    overlay.chatBtn.large.addEventListener("click", handleShowClick);
    overlay.closeChatBtn = document.querySelector(".overlay-chat-btn__container .overlay-close-chat-btn");
    overlay.closeChatBtn.addEventListener("click", handleHideClick);

    /* Chat Init */
    hideOverlayChatBtn();

    // Init Gorgias Chat
    let initGorgiasChatPromise = (window.GorgiasChat) ? window.GorgiasChat.init() : new Promise(function (resolve) { window.addEventListener('gorgias-widget-loaded', function () { resolve();})});
    initGorgiasChatPromise.then(chatLoadCallback);
  }

  /*
    =====
    Load
    =====
  */
  function chatBtnFindInterval() {
    // Check if found
    gorgias.container = document.querySelector("#gorgias-chat-container");

    if (!gorgias.container) return;

    clearInterval(interval.chat);
    clearTimeout(timeout.chat);

    initChat();
  }

  async function chatLoadCallback() {
    // Search for chat container
    interval.chat = setInterval(chatBtnFindInterval, 250);

    // Stop searching after duration
    timeout.chat = setTimeout(() => {
      clearInterval(interval.chat);
      clearTimeout(timeout.chat);
    }, 20000);

    chatBtnFindInterval();
  }

  function initChat() {
    // Hide chat container
    gorgias.container.classList.add("sk-hidden");

    // Add find chat btn click listeners when clicking overlay btn
    overlay.chatBtn.small.addEventListener("click", startFindChatCallback);
    overlay.chatBtn.large.addEventListener("click", startFindChatCallback);

    // If closed, then only show the small chat button
    // Otherwise, show large
    if (GorgiasChat && !GorgiasChat.isBusinessHours()) {
      showOverlayChatBtn("small");
    } else {
      showOverlayChatBtn("large");
    }

    overlay.chatBtn.small.setAttribute("data-found", "true");
    overlay.chatBtn.large.setAttribute("data-found", "true");
  }

  /*
    =====
    Find
    =====
  */
  function startFindChatCallback(e) {
    if (e) e.preventDefault();

    // Remove find listeners
    overlay.chatBtn.small.removeEventListener("click", startFindChatCallback);
    overlay.chatBtn.large.removeEventListener("click", startFindChatCallback);

    // Simulate click
    handleShowClick();

    // Search for chat btn
    interval.chatBtn = setInterval(findChatCallback, 250);
  }

  function findChatCallback() {
    // Check for chat button
    gorgias.chatBtn = document.querySelector("#gorgias-chat-container #chat-button");
    gorgias.chatWindow = document.querySelector("#gorgias-chat-container #chat-window");

    if (!gorgias.chatBtn || !gorgias.chatWindow) return;

    // Found
    if (overlay.chatBtn.small && overlay.chatBtn.large) {
      overlay.chatBtn.small.addEventListener("click", handleShowClick);
      overlay.chatBtn.large.addEventListener("click", handleShowClick);
      overlay.chatBtn.small.setAttribute("data-found", "true");
      overlay.chatBtn.large.setAttribute("data-found", "true");
    }

    function chatCallback(mutations, observer) {
      mutations.forEach(function (mutation) {
        if (mutation.type === "attributes") {
          if (window.getComputedStyle(mutation.target).display === "none") {
            hideCallback();
          }
        }
      });
    }

    const chatOptions = {attributes: true};

    const chatObserver = new MutationObserver(chatCallback);
    chatObserver.observe(gorgias.chatWindow, chatOptions);

    // showOverlayChatBtn();

    clearInterval(interval.chatBtn);
  }

  /*
    =====
    Show
    =====
  */
  function showCallback() {
    hideOverlayChatBtn("large");
    hideOverlayChatBtn("small");
    showOverlayCloseChatBtn();
    showContainer();
    showWindow();
  }

  function showContainer() {
    gorgias.container.classList.remove("sk-hidden");
  }

  function showWindow() {
    try {
      GorgiasChat.open();
    } catch {
      console.warn("GorgiasChat not found. -sk");
    }
  }

  function showOverlayChatBtn(view = "large") {
    if (view === "large") {
      overlay.chatBtn.large.classList.remove("sk-hidden");
    } else {
      overlay.chatBtn.small.classList.remove("sk-hidden");
    }
  }

  function showOverlayCloseChatBtn() {
    overlay.closeChatBtn.classList.remove("sk-hidden");
  }

  /*
    =====
    Hide
    =====
  */
  function hideCallback() {
    hideOverlayCloseChatBtn();
    hideWindow();
    hideContainer();
    showOverlayChatBtn("small");
  }

  function hideContainer() {
    gorgias.container.classList.add("sk-hidden");
  }

  function hideWindow() {
    try {
      GorgiasChat.close();
    } catch {
      console.warn("GorgiasChat not found. -sk");
    }
  }

  function hideOverlayChatBtn(view = "large") {
    if (view === "large") {
      overlay.chatBtn.large.classList.add("sk-hidden");
    } else {
      overlay.chatBtn.small.classList.add("sk-hidden");
    }
  }

  function hideOverlayCloseChatBtn() {
    overlay.closeChatBtn.classList.add("sk-hidden");
  }

  /*
    =====
    Click
    =====
  */
  function handleShowClick(e = undefined) {
    if (e) e.preventDefault();
    showCallback();
  }

  function handleHideClick(e = undefined) {
    if (e) e.preventDefault();
    hideCallback();
  }

  init();

  return Object.freeze({
    hideChatWindow: hideCallback,
    init,
  });
}

GChat = GChat();
